import { render, staticRenderFns } from "./HomeTechstack.vue?vue&type=template&id=0e99bcc2&scoped=true&"
import script from "./HomeTechstack.vue?vue&type=script&lang=js&"
export * from "./HomeTechstack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99bcc2",
  null
  
)

export default component.exports